import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCheckCircle, FaAward, FaDollarSign, FaTruck, FaHandshake } from 'react-icons/fa';

function WhyChooseUs() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const reasons = [
    { title: 'Reliable and Consistent Supply', icon: FaCheckCircle, description: 'Dependable product availability and timely delivery you can count on' },
    { title: 'Quality-Focused Sourcing', icon: FaAward, description: 'Rigorous quality standards ensuring products meet your expectations' },
    { title: 'Competitive Pricing', icon: FaDollarSign, description: 'Fair pricing that delivers value without compromising on quality' },
    { title: 'Efficient Logistics Coordination', icon: FaTruck, description: 'Streamlined supply chain management for smooth operations' },
    { title: 'Strong Supplier and Customer Relationships', icon: FaHandshake, description: 'Building lasting partnerships based on trust and mutual success' }
  ];

  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 50%, rgba(71, 85, 105, 0.85) 100%), url("https://images.unsplash.com/photo-1542838132-92c53300491e?w=1600&q=80") center/cover',
      padding: '140px 0 100px',
      position: 'relative',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center'
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at top right, rgba(59, 130, 246, 0.15) 0%, transparent 50%)',
      pointerEvents: 'none'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: 800,
      color: '#ffffff',
      marginBottom: '20px',
      textShadow: '0 4px 12px rgba(0,0,0,0.3)',
      letterSpacing: '-0.02em'
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: '#e2e8f0',
      maxWidth: '700px',
      margin: '0 auto',
      lineHeight: 1.6
    }
  };

  return (
    <>
      {/* Hero Section */}
      <div style={{...styles.heroSection, backgroundPositionY: `${scrollY * 0.5}px`}}>
        <div style={styles.heroOverlay}></div>
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row>
            <Col className="text-center">
              <h1 style={styles.heroTitle}>Why Choose Manami Trading</h1>
              <p style={styles.heroSubtitle}>
                Your trusted partner for quality products and reliable service
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Reasons Section */}
      <div style={{ padding: '80px 0', backgroundImage: 'linear-gradient(rgba(248, 250, 252, 0.95), rgba(248, 250, 252, 0.95)), url("https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1600&q=80")', backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center', backgroundPositionY: `${scrollY * 0.3}px` }}>
        <Container>
          <Row>
            {reasons.map((reason, index) => (
              <Col md={6} lg={4} key={index} className="mb-4">
                <div style={{ 
                  background: 'white', 
                  padding: '40px 30px', 
                  borderRadius: '12px', 
                  height: '100%', 
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(37, 99, 235, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}>
                  <reason.icon style={{ fontSize: '2.5rem', color: '#2563eb', marginBottom: '20px' }} />
                  <h4 style={{ color: '#0f172a', fontWeight: 700, fontSize: '1.25rem', marginBottom: '12px' }}>{reason.title}</h4>
                  <p style={{ color: '#64748b', lineHeight: 1.6, margin: 0, fontSize: '0.95rem' }}>{reason.description}</p>
                </div>
              </Col>
            ))}
          </Row>

          {/* Quote Section */}
          <Row className="mt-5">
            <Col md={12}>
              <div style={{ 
                background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)', 
                padding: '50px 40px', 
                borderRadius: '16px',
                textAlign: 'center',
                boxShadow: '0 8px 32px rgba(37, 99, 235, 0.2)'
              }}>
                <p style={{ 
                  fontSize: '1.5rem', 
                  color: 'white', 
                  fontStyle: 'italic', 
                  margin: 0,
                  lineHeight: 1.6,
                  fontWeight: 500
                }}>
                  "We focus on delivering value while ensuring products meet required standards and customer expectations"
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default WhyChooseUs;
